/**
 * Normalizes a portal domain URL by ensuring it has https:// protocol
 * and no trailing slashes. Returns a default Bynder URL if none provided.
 */
export function parseUrl(url?: string) {
    if (!url) {
        return `https://dam.bynder.com`;
    }

    const withoutProtocol = url.replace(/^https?:\/\//i, '');
    const withoutTrailingSlashes = withoutProtocol.replace(/\/+$/i, '');

    return `https://${withoutTrailingSlashes}`;
}
